import { useState, useCallback, useMemo } from 'react';

interface Toast {
  id: string;
  title: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  // ✅ Stabiliser showToast avec useCallback pour éviter les boucles infinies
  const showToast = useCallback(({ title, message, type }: Omit<Toast, 'id'>) => {
    const id = Math.random().toString(36).substr(2, 9);
    const toast = { id, title, message, type };
    
    setToasts((current) => [...current, toast]);

    setTimeout(() => {
      setToasts((current) => current.filter((t) => t.id !== id));
    }, 5000);
  }, []);

  // ✅ Retourner un objet mémorisé pour éviter les re-renders
  return useMemo(() => ({ toasts, showToast }), [toasts, showToast]);
}